export default __webpack_public_path__ + "static/media/BOOTSTRAP.89a759a9.jpg";